<template>
  <div class="sidebar">
    <div class="sidebar-main">
      <header>
        <button class="close-button" @click="toggleSidebar">
          <svg xmlns="http://www.w3.org/2000/svg" width="12.728" height="12.728"><path data-name="Rectangle 13" d="M1.414 0l11.314 11.314-1.415 1.414L0 1.414z"/><path data-name="Rectangle 14" d="M0 11.314L11.314 0l1.414 1.415L1.414 12.728z"/></svg>
        </button>
        <div class="ui-controls">
          <button @click="setUI('light')" class="ui-button ui-button--light"></button>
          <button @click="setUI('dark')" class="ui-button ui-button--dark"></button>
        </div>
      </header>
      <nav>
        <router-link to="/" class="link">Discover</router-link>
        <router-link to="/directory" class="link">Directory</router-link>
        <router-link to="/info" class="link">Information</router-link>
        <a href="https://colorspark.app" target="_blank" class="link">ColorSpark</a>
      </nav>
    </div>
    <footer>
      <div>
        <span>© 2019 - </span>
        <a href="https://openform.studio" target="_blank">openform.studio</a>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'app-sidebar',
  methods: {
    ...mapActions('ui', [
      'toggleSidebar',
      'setUI'
    ]),
  }
}
</script>

<style lang="scss" scoped>
  .sidebar {
    height: 100%;
    width: 20rem;
    background: #fff;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 50;
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .app.dark & {
      background: #000;
    }

    @media screen and (max-width: 40rem) {
      width: 75vw;
      padding: 1rem;
    }
  }

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  nav {
    margin-top: 1.5rem;
  }

  .close-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.75rem;
    border-radius: 100%;
    transition: all 250ms;

    &:hover {
      background: #f8f8f8;
    }

    &:active {
      background: #f0f0f0;
      transform: scale(0.9);
    }

    .app.dark & {
      svg path {
        fill: #fff;
      }
    }
  }

  .ui-button {
    width: 0.875rem;
    height: 0.875rem;
    border: 1px solid #000;
    border-radius: 0.5rem;
    box-shadow: 0 0 0 0rem rgba(0,0,0,0);
    transition: box-shadow 250ms, transform 250ms;

    &.ui-button--light {
      background: #fff;
      margin-right: 0.5rem;
    }

    &.ui-button--dark {
      background: #000;
    }

    .app.dark & {
      border-color: #fff;
    }

    &:hover {
      box-shadow: 0 0 0 0.375rem rgba(0,0,0,0.05);

      .app.dark & {
        box-shadow: 0 0 0 0.375rem rgba(255,255,255,0.1);
      }
    }

    &:active {
      box-shadow: 0 0 0 0.375rem rgba(0,0,0,0.1);
      transform: scale(0.9);

      .app.dark & {
        box-shadow: 0 0 0 0.375rem rgba(255,255,255,0.2);
      }
    }
  }

  .link {
    display: block;
    font-size: 0.875rem;
    border-radius: 0.5rem;
    width: 100%;
    padding: 1rem;
    margin: 0.5rem 0;
    color: #8c8c8c;

    .app.dark & {
      color: #646464;
    }

    &.router-link-exact-active {
      background: #f0f0f0;
      color: #000;

      &:hover {
        background: #f0f0f0;
        color: #000;
      }

      .app.dark & {
        color: #fff;
        background: #0f0f0f;
      }
    }

    &:hover  {
      background: #f8f8f8;

      .app.dark & {
        background: #070707;
      }
    }
  }

  footer {
    padding: 1rem;
    font-size: 0.75rem;
    color: #8c8c8c;
  }
</style>
